import ApiService from './api.service';

// BE resource REST = `category` (danh mục nhóm sản phẩm/dịch vụ — TR-2 dùng cho "Nhóm").
const BASE_URL = 'category';

/**
 * CategoryService — danh mục nhóm (category). Dùng cho dropdown "Nhóm" ở báo giá (SO-002).
 * BE controller: backend/src/modules/category/controllers/category.controller.ts
 */
export const CategoryService = {
  /**
   * List danh mục nhóm.
   * @param {Object} params { getFull?, page?, limit?, search? }
   */
  getAll(params) {
    return ApiService.query(BASE_URL, { params });
  },
};

export default CategoryService;
